import { TownPage } from "./town-page";

export default function Medway() {
  return (
    <TownPage
      town="Medway"
      path="/service-areas/medway"
      headline="Reliable Care for Medway"
      description="TLC Associates LLC serves Medway's family-friendly neighborhoods, tree-lined streets, and established homes with year-round landscape care. Lawn maintenance on Main Street and garden design in the Choate Park area are part of the local work already provided by the company. Medway sits directly north of Franklin and is within a ten-minute drive of the home base, allowing responsive service for scheduled maintenance and urgent needs. Spring cleanups, weekly mowing, pruning, planting, and landscape renovation can be planned around the way each property is used. Mature trees and established beds benefit from careful seasonal attention, while newer changes can be coordinated through landscaping and stonework. Snow plowing and ice management extend that same property care into winter."
    />
  );
}